// src/store/useStoreDeliveryUser.ts
import { create } from "zustand";
import axios from "axios";
import { URL } from "../../lib/apis";

interface VehicleState {
  DeliveryUser: any[]; // L'état pour stocker les données de véhicules
  loadingDeliveryUser: boolean; // Nouveau state pour suivre l'état du chargement
  fetchDeliveryUser: (user_id: string) => Promise<void>; // Fonction pour récupérer les véhicules
}

const useStoreDeliveryUser = create<VehicleState>((set) => ({
  DeliveryUser: [],
  loadingDeliveryUser: false,
  fetchDeliveryUser: async (user_id: string) => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("User is not authenticated");
    }

    if (!token) {
      console.error("No token available. User might not be authenticated.");
      return;
    }
    set({ loadingDeliveryUser: true }); // Démarre le chargement
    try {
      const response = await axios.get(
        `${URL}/orders/users/${user_id}/deliveries`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in headers
          },
        }
      );
      set({
        DeliveryUser: response.data.data,
        loadingDeliveryUser: false,
      }); // Met à jour les données et arrête le chargement
    } catch (error) {
      console.error("Error fetching DeliveryUser:", error);
      set({ loadingDeliveryUser: false }); // Arrête le chargement en cas d'erreur
    }
  },
}));

export default useStoreDeliveryUser;
